import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StudyForm from './components/StudyForm';
import { useSEO, generateOrganizationSchema, generateWebPageSchema } from '../../utils/seo';

export default function StudyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || '';
  
  const schemas = [
    generateOrganizationSchema(),
    generateWebPageSchema(
      'Demande d\'Étude Gratuite - LED 1€',
      'Demandez votre étude personnalisée gratuite pour votre projet de rénovation LED à Paris. Nos experts analysent vos besoins et vous proposent une solution sur mesure avec financement CEE. Réponse sous 24h.',
      `${siteUrl}/etude-gratuite`
    )
  ];

  useSEO({
    title: 'Demande d\'Étude Gratuite - LED 1€ | POWERENO',
    description: 'Demandez votre étude personnalisée gratuite pour votre projet de rénovation LED à Paris. Nos experts analysent vos besoins et vous proposent une solution sur mesure avec financement CEE. Réponse sous 24h.',
    keywords: 'étude gratuite LED Paris, devis rénovation LED, audit éclairage gratuit, projet LED tertiaire',
    canonical: `${siteUrl}/etude-gratuite`,
    schema: schemas
  });

  return (
    <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
      <div className="bg-white">
        <Navbar />
        <StudyForm />
        <Footer />
      </div>
    </Suspense>
  );
}
